type EventCallback<T> = (data: T) => void;

interface EventBus {
  on<T>(event: string, callback: EventCallback<T>): void;
  dispatch<T>(event: string, data: T): void;
  remove<T>(event: string, callback?: EventCallback<T>): void;
}

const listeners = new Map<string, Map<Function, EventListener>>();
const eventBus: EventBus = {
  on<T>(event: string, callback: EventCallback<T>): void {
    if (!listeners.has(event)) listeners.set(event, new Map());
    if (listeners.get(event)!.has(callback)) return;
    const wrappedCallback = (e: CustomEvent<T>) => callback(e.detail);
    listeners.get(event)!.set(callback, wrappedCallback as EventListener);
    document.addEventListener(event, wrappedCallback as EventListener);
  },
  dispatch<T>(event: string, data: T): void {
    document.dispatchEvent(new CustomEvent<T>(event, { detail: data }));
  },
  remove<T>(event: string, callback?: EventCallback<T>): void {
    if (callback) {
      const wrappedCallback = listeners.get(event)?.get(callback);
      if (wrappedCallback) document.removeEventListener(event, wrappedCallback);
      listeners.get(event)?.delete(callback);
    } else {
      listeners.get(event)?.forEach(listener => document.removeEventListener(event, listener));
      listeners.delete(event);
    }
  },
};

export default eventBus;
